import { createAsyncThunk } from "@reduxjs/toolkit";

import { CSRF_HEADER, ajax, getCSRFToken } from "../../../utils/ajax";
import { IVoucher } from "../models";

/**
 * Deletes a voucher code from the system.
 *
 * This permanently removes a voucher, making it invalid for future use.
 * This operation is typically restricted to CSR agents and should be used
 * with caution. Common use cases include:
 * - Invalidating a compromised or leaked voucher code
 * - Removing test/temporary vouchers
 * - Cleaning up expired or unused vouchers
 *
 * @param voucher - The voucher object to delete (must include URL)
 * @returns Promise resolving to the deleted voucher's code (for confirmation)
 *
 * @example
 * dispatch(deleteVoucherCode(voucher))
 */
export const deleteVoucherCode = createAsyncThunk(
    "csr/deleteVoucherCode",
    async (voucher: IVoucher): Promise<string> => {
        await ajax
            .delete(voucher.url)
            .set(CSRF_HEADER, await getCSRFToken())
            .set("Accept", "application/json");
        return voucher.code;
    },
);
